import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CareerService } from '../career/career.service';
import { ApplyJobServiceService } from './services/apply-job-service.service';
import Swal from 'sweetalert2';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-applyjob',
  imports: [CommonModule,FormsModule,ReactiveFormsModule,MatIconModule,MatFormFieldModule,MatSelectModule,MatInputModule,NgxMatSelectSearchModule,MatTooltipModule    
  ],
  templateUrl: './applyjob.component.html',
  styleUrl: './applyjob.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ApplyjobComponent {
 applyForm!: FormGroup;
 submitted = false;
 jobs: any[] = [];
 states: any[] = [];
 districts: any[] = [];
constituencies: string[] = [];
 experienceList: number[] = [0, 1, 2, 3, 4, 5, 6];

 // state for search
 filteredStates: any[] = [];
  stateFilterCtrl = new FormControl('');

  districtFilterCtrl = new FormControl('');
constituencyFilterCtrl = new FormControl('');

filteredDistricts: any[] = [];
filteredConstituencies: string[] = [];


districtData: any[] = [
  {
    districts: [
      {
        name: 'Alluri Sitharama Raju',
        constituencies: ['Araku Valley', 'Paderu', 'Rampachodavaram']
      },
      {
        name: 'Anakapalli',
        constituencies: ['Anakapalle', 'Chodavaram', 'Elamanchili', 'Madugula', 'Narsipatnam', 'Payakaraopet', 'Pendurthi']
      },
      {
        name: 'Ananthapur',
        constituencies: ['Anantapur Rural', 'Anantapur Urban', 'Guntakal', 'Kalyandurg', 'Rayadurg', 'Singanamala', 'Tadipatri', 'Uravakonda']
      },
      {
        name: 'Annamayya ',
        constituencies: ['Madanapalle', 'Pileru', 'Railway Kodur', 'Rajampet', 'Rayachoti', 'Thamballapalle']
      },
      {
        name: 'Bapatla',
        constituencies: ['Addanki', 'Bapatla', 'Chirala', 'Parchur', 'Repalle', 'Vemuru']
      },
      {
        name: 'Chittoor',
        constituencies: ['Chittoor', 'Gangadhara Nellore', 'Kuppam', 'Nagari', 'Palamaner', 'Punganur', 'Puthalapattu']
      },
      {
        name: 'Dr. B.R. Ambedkar Konaseema',
        constituencies: ['Amalapuram', 'Kothapeta', 'Mandapeta', 'Mummidivaram', 'P. Gannavaram', 'Ramachandrapuram', 'Razole']
      },
         {
        name: 'East Godavari',
        constituencies: ['Anaparthy', 'Kovvur', 'Nidadavole', 'Rajahmundry City', 'Rajahmundry Rural', 'Rajanagaram']
      },
      {
        name: 'Guntur',
        constituencies: ['Guntur East', 'Guntur West', 'Mangalagiri', 'Ponnur', 'Prathipadu', 'Tadikonda', 'Tenali']
      },
               {
        name: 'Kakinada',
        constituencies: ['Jaggampeta', 'Kakinada City', 'Kakinada Rural', 'Peddapuram', 'Pithapuram', 'Prathipadu', 'Tuni']
      },
               {
        name: 'Krishna',
        constituencies: ['Avanigadda', 'Gannavaram', 'Gudivada', 'Machilipatnam', 'Pamarru', 'Pedana', 'Penamaluru']
      },
               {
        name: 'Kurnool',
        constituencies: ['Adoni', 'Alur', 'Banaganapalle', 'Kodumur', 'Kurnool', 'Mantralayam', 'Pattikonda', 'Yemmiganur']
      },
               {
        name: 'Nandyal',
        constituencies: ['Allagadda', 'Dhone', 'Nandikotkur', 'Nandyal', 'Panyam', 'Srisailam']
      },
                    {
        name: 'NTR',
        constituencies: ['Jaggayyapeta', 'Mylavaram', 'Nandigama', 'Tiruvuru', 'Vijayawada Central', 'Vijayawada East', 'Vijayawada West']
      },
                    {
        name: 'Palnadu',
        constituencies: ['Chilakaluripet', 'Gurazala', 'Macherla', 'Narasaraopet', 'Pedakurapadu', 'Sattenapalle', 'Vinukonda']
      },
                    {
        name: 'Parvathipuram Manyam',
        constituencies: ['Kurupam', 'Palakonda', 'Parvathipuram', 'Salur']
      },
                    {
        name: 'Prakasam',
        constituencies: ['Darsi', 'Giddalur', 'Kanigiri', 'Kondapi', 'Markapuram', 'Ongole', 'Santhanuthalapadu', 'Yerragondapalem']
      },
                    {
        name: 'SPSR Nellore',
        constituencies: ['Atmakur', 'Kandukur', 'Kavali', 'Kovur', 'Nellore City', 'Nellore Rural', 'Sarvepalli', 'Udayagiri']
      },
                          {
        name: 'Sri Sathya Sai',
        constituencies: ['Dharmavaram', 'Hindupur', 'Kadiri', 'Madakasira', 'Penukonda', 'Puttaparthi']
      },
                          {
        name: 'Srikakulam',
        constituencies: ['Amadalavalasa', 'Etcherla', 'Ichchapuram', 'Narasannapeta', 'Palasa', 'Pathapatnam', 'Srikakulam', 'Tekkali']
      },
                          {
        name: 'Tirupati',
        constituencies: ['Chandragiri', 'Gudur', 'Satyavedu', 'Srikalahasti', 'Sullurpeta', 'Tirupati', 'Venkatagiri']
      },
                          {
        name: 'Visakhapatnam',
        constituencies: ['Bheemunipatnam', 'Gajuwaka', 'Visakhapatnam East', 'Visakhapatnam North', 'Visakhapatnam South', 'Visakhapatnam West']
      },
                                {
        name: 'Vizianagaram',
        constituencies: ['Bobbili', 'Cheepurupalli', 'Gajapathinagaram', 'Nellimarla', 'Rajam', 'Srungavarapukota', 'Vizianagaram']
      },
                                {
        name: 'West Godavari',
        constituencies: ['Achanta', 'Bhimavaram', 'Narsapuram', 'Palakollu', 'Tadepalligudem', 'Tanuku', 'Undi']
      },
                                {
        name: 'YSR Kadapa',
        constituencies: ['Badvel', 'Jammalamadugu', 'Kadapa', 'Kamalapuram', 'Mydukur', 'Proddatur', 'Pulivendla']
      },
    ]
  }
];

  constructor(private fb: FormBuilder, private careerService: CareerService, private applyJobService: ApplyJobServiceService) {}

  ngOnInit(): void {
this.applyForm = this.fb.group({
  candidateName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern(/^[A-Za-z ]+$/)]],
  email: ['', [Validators.required, Validators.email, Validators.pattern(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    )]],
  phone: ['', [
    Validators.required,
    Validators.pattern(/^[6-9][0-9]{9}$/),
    Validators.minLength(10),
    Validators.maxLength(10)
  ]],
  state: [
  { value: 'Andhra Pradesh', disabled: true },
  Validators.required
],
 district: ['', Validators.required],
constituency: ['', Validators.required],
  appliedRole: ['', Validators.required],
  resumeContent: ['', [Validators.required, Validators.minLength(200), Validators.maxLength(10000)]],
  yearsOfExperience: ['', Validators.required],
  reference: [''] // 👈 new field
});

  this.loadJobs();
  // this.loadStates();
   this.loadAndhraDistricts();
      // 🔎 listen for search input
    this.stateFilterCtrl.valueChanges.subscribe(search => {
      this.filterStates(search || '');
    });

    this.districtFilterCtrl.valueChanges.subscribe(value => {
  this.filterDistricts(value || '');
});

this.constituencyFilterCtrl.valueChanges.subscribe(value => {
  this.filterConstituencies(value || '');
});
}

loadAndhraDistricts() {
  const ap = this.districtData.find(d => d.districts);

  if (ap) {
    this.districts = ap.districts;
    // ⭐ IMPORTANT: show data by default
    this.filteredDistricts = [...ap.districts];
  }
}

onDistrictChange(districtName: string) {

  const selected = this.districts.find(d => d.name === districtName);

  this.constituencies = selected ? selected.constituencies : [];

  // ⭐ IMPORTANT: show full list initially
  this.filteredConstituencies = [...this.constituencies];

  this.applyForm.patchValue({
    constituency: ''
  });

  this.constituencyFilterCtrl.setValue('');
}

filterDistricts(search: string) {
  const value = search?.toLowerCase().trim() || '';

  if (!value) {
    // ⭐ reset when empty
    this.filteredDistricts = [...this.districts];
    return;
  }

  this.filteredDistricts = this.districts.filter(d =>
    d.name.toLowerCase().includes(value)
  );
}

filterConstituencies(search: string) {
  const value = search?.toLowerCase().trim() || '';

  if (!value) {
    this.filteredConstituencies = [...this.constituencies];
    return;
  }

  this.filteredConstituencies = this.constituencies.filter(c =>
    c.toLowerCase().includes(value)
  );
}




loadStates() {
  this.applyJobService.getAllStates().subscribe({
    next: (res) => {
      if (res.isSuccess) {
        this.states = res.result;
        this.filteredStates = res.result;

        // ⭐ set default Andhra Pradesh
        const defaultState = this.states.find(s => s.stateName === 'Andhra Pradesh');

        if (defaultState) {
          this.applyForm.patchValue({
            state: defaultState.stateName
          });

           // ⭐ disable dropdown
          this.applyForm.get('state')?.disable();

          console.log('Default State ID:', defaultState.stateId);
        }
      }
    }
  });
}

onStateChange(stateId: number) {
  console.log('Selected State ID:', stateId);
}

  filterStates(search: string) {
    const value = search.toLowerCase().trim();

    this.filteredStates = this.states.filter(state =>
      state.stateName.toLowerCase().includes(value)
    );
  }

loadJobs() {
  this.careerService.getJobs().subscribe({
    next: (data: any) => {

      console.log('Jobs API:', data);

      this.jobs = data.data || data; // handle both formats

    },
    error: (err) => {
      console.error('Error loading jobs:', err);
    }
  });
}

onSubmit() {
 if (this.applyForm.invalid) {
  this.applyForm.markAllAsTouched();
    return;
  }
  this.submitted = true;

  const formValue = this.applyForm.getRawValue();

const selectedJob = this.jobs.find(
  job => job.id === Number(formValue.appliedRole)
);

const payload = {
  full_name: formValue.candidateName,
  email: formValue.email,
  phone: formValue.phone,
  state: formValue.state,
  district: formValue.district,
  constituency: formValue.constituency,

  job_id: Number(formValue.appliedRole),
  applied_role: selectedJob?.title || '',

  resume_content: formValue.resumeContent,
  reference_name: formValue.reference || '',
  experience: Number(formValue.yearsOfExperience)
};
  console.log('Final Payload:', payload);

    // 🔄 Optional: show loading
  Swal.fire({
    title: 'Submitting...',
    text: 'Please wait while we submit your application',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

this.applyJobService.applyJob(payload).subscribe({
  next: (res: any) => {
    Swal.close();

    console.log('Application Response:', res);

    if (res && res.id) {
      Swal.fire({
        icon: 'success',
        title: 'Application Submitted!',
        text: 'Your job application has been submitted successfully.',
        confirmButtonText: 'OK'
      });

      this.resetApplicationForm();
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Submission Failed',
        text: 'Unable to submit your application. Please try again.'
      });

      this.submitted = false;
    }
  },

  error: (err) => {
    Swal.close();

    console.error('API Error:', err);

    let errorMessage = 'Something went wrong while submitting your application.';

    if (err?.error?.detail) {
      errorMessage = err.error.detail;
    } else if (err?.error?.message) {
      errorMessage = err.error.message;
    } else if (err?.message) {
      errorMessage = err.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Submission Failed',
      text: errorMessage
    });

    this.submitted = false;
  }
});

  
}

  // easy access
get f() {
  // console.log('Form Controls:', this.applyForm.controls);
  return this.applyForm.controls;
  
}

blockScriptKeys(event: KeyboardEvent) {
  if (event.key === '<' || event.key === '>') {
    event.preventDefault();
  }
}

blockScriptKeysphone(event: KeyboardEvent) {
  // allow control keys
  const allowedKeys = [
    'Backspace',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Delete'
  ];

  if (allowedKeys.includes(event.key)) return;

  // block < and >
  if (event.key === '<' || event.key === '>') {
    event.preventDefault();
    return;
  }

  // 🚫 block anything that is NOT a number
  if (!/^[0-9]$/.test(event.key)) {
    event.preventDefault();
  }
}

blockPastephone(event: ClipboardEvent) {
  const pastedText = event.clipboardData?.getData('text') || '';

  // 🚫 block < >
  if (pastedText.includes('<') || pastedText.includes('>')) {
    event.preventDefault();
    return;
  }

  // 🚫 block if not fully numeric
  if (!/^[0-9]+$/.test(pastedText)) {
    event.preventDefault();
  }

  // Optional safety: limit to 10 digits
  if (pastedText.length > 10) {
    event.preventDefault();
  }
}

blockPaste(event: ClipboardEvent) {
  const pastedText = event.clipboardData?.getData('text') || '';

  if (pastedText.includes('<') || pastedText.includes('>')) {
    event.preventDefault();
  }
}

allowOnlyLetters(event: KeyboardEvent) {
  const char = event.key;

  // allow control keys
  if (
    char === 'Backspace' ||
    char === 'Tab' ||
    char === 'ArrowLeft' ||
    char === 'ArrowRight' ||
    char === 'Delete'
  ) {
    return;
  }

  // allow only letters and space
  const regex = /^[A-Za-z ]$/;

  if (!regex.test(char)) {
    event.preventDefault();
  }
}

blocknumPaste(event: ClipboardEvent) {
  const pastedText = event.clipboardData?.getData('text') || '';

  const regex = /^[A-Za-z ]+$/;

  if (!regex.test(pastedText)) {
    event.preventDefault();
  }
}

resetApplicationForm() {
  this.applyForm.reset();

  // Reset validation state
  this.applyForm.markAsPristine();
  this.applyForm.markAsUntouched();

  Object.keys(this.applyForm.controls).forEach(key => {
    this.applyForm.get(key)?.setErrors(null);
    this.applyForm.get(key)?.markAsPristine();
    this.applyForm.get(key)?.markAsUntouched();
  });

  // Restore default state
  this.applyForm.patchValue({
    state: 'Andhra Pradesh'
  });

  this.applyForm.get('state')?.disable();

  this.constituencies = [];
  this.filteredConstituencies = [];
  this.filteredDistricts = [...this.districts];

  this.stateFilterCtrl.setValue('');
  this.districtFilterCtrl.setValue('');
  this.constituencyFilterCtrl.setValue('');

  this.submitted = false;
}

// states
}
